/**
 * @file defined a map that maps the states and their comments.
 * e.g. the value of 'comment.enableTracing' is the comment that need to be put right above the corresponding variable of 'EnableTracing' in the Response File
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

const comment = {};

comment.installInstance = `
## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# Options File Template for Update Silent Installation.
#
# This file is a options file (i.e., response file) for the MicroStrategy 
# Update Installer. Options files are used with "-options" on 
# the command line to modify wizard settings.
# 
# The settings that can be specified for the wizard are listed below. To use
# this template, follow these steps:
# 
#    1. Enable a setting below by removing leading '###' characters from the
#    line (search for '###' to find settings you can change).
# 
#    2. Specify a value for a setting by replacing the character's '<value>'.
#    Read each setting's documentation for information on how to specify its
#    value.
# 
#    3. Save the changes to the file.
# 
#    4. To use the options file on a silent installation, specify -silent 
#    -options <file-name> as a command line arguments to the wizard, where
#    <file-name> is the name of this options file.
#
#       For example:
#
#	setup.sh -silent -options options.txt 
#
#
#
## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# Installation Properties
#
# Please specify general installation properties.

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# MicroStrategy Installation Selection
#
# MicroStrategy Update packages can only be applied to existing installations.
#
# To select an existing Installation, specify its home path. 
#
#       For example 
#
#       install.Instance=/home/user/MicroStrategy
#

`;

comment.installOperation = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# MicroStrategy Operation to perform on instance
#
# For an existing Installation, Legal values are: 
#
#    UPDATE_INSTALL    - Indicates a update package will be installed
#    REMOVE_UPDATE     - Indicates a update package will be removed
#
#       For example 
#
#       install.Operation=UPDATE_INSTALL
#

`;

export default comment;
